var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2686 0H0.518999C0.231589 0 0.00585938 0.228876 0.00585938 0.52029V6.76377C0.00585938 7.04988 0.231589 7.28406 0.518999 7.28406H10.2686C10.5509 7.28406 10.7818 7.04988 10.7818 6.76377V0.52029C10.7818 0.228876 10.5509 0 10.2686 0Z",
    fill: "#FFDB1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.88602C0 10.1721 0.230913 10.4063 0.513139 10.4063H1.06733C1.28285 9.31885 2.16545 8.46563 3.26357 8.32515H0.518271C0.333489 8.32515 0.164256 8.29388 0 8.23145V9.88602Z",
    fill: "#FFDB1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8503 10.4059H15.4866C15.7688 10.4059 15.9998 10.1717 15.9998 9.88563V5.32788C15.9998 4.51098 14.0344 2.60156 12.9569 2.60156H11.8075V6.76389C11.8075 7.62231 11.1147 8.32476 10.268 8.32476H3.93066C5.02883 8.46523 5.91143 9.31846 6.1269 10.4059H9.79071C10.0268 9.20925 11.0685 8.29874 12.3205 8.29874C13.5675 8.29869 14.6143 9.2092 14.8503 10.4059ZM12.6489 3.88142C15.2762 3.75135 15.1685 6.50369 15.1685 6.50369H12.6489V3.88142Z",
    fill: "#FFDB1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3182 12.4844C13.1741 12.4844 13.8679 11.7809 13.8679 10.9131C13.8679 10.0453 13.1741 9.3418 12.3182 9.3418C11.4624 9.3418 10.7686 10.0453 10.7686 10.9131C10.7686 11.7809 11.4624 12.4844 12.3182 12.4844Z",
    fill: "#FFDB1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59558 12.4844C4.45144 12.4844 5.14526 11.7809 5.14526 10.9131C5.14526 10.0453 4.45144 9.3418 3.59558 9.3418C2.73971 9.3418 2.0459 10.0453 2.0459 10.9131C2.0459 11.7809 2.73971 12.4844 3.59558 12.4844Z",
    fill: "#FFDB1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/inProgress.44599ed2a8f94bef879d128422887a67.svg";
export { ForwardRef as ReactComponent };